import { Minus, Plus } from '@phosphor-icons/react';
import { useEffect, useRef, useState } from 'react';
import { StringUtils } from '@manifoldxyz/js-ts-utils';
import { MarkdownRenderer } from '@manifoldxyz/react-component-library';
import useMainStore from '@/store/mainStore';

export default function Description() {
  const [isExpandable, setIsExpandable] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const textEl = useRef<HTMLDivElement>(null);
  const studioInstance = useMainStore((state) => state.studioInstance);

  // Setup resize observer to check content height
  useEffect(() => {
    if (!textEl.current) return;

    const resizeObserver = new ResizeObserver(() => {
      if (textEl.current) {
        setIsExpandable(textEl.current.clientHeight > 200);
      }
    });

    resizeObserver.observe(textEl.current);
    return () => resizeObserver.disconnect();
  }, []);

  const description =
    studioInstance?.publicData?.description || studioInstance?.publicData?.asset?.description || '';

  return (
    <div
      className={`
        m-claim--relative m-claim--h-auto m-claim--w-full m-claim--overflow-hidden
        ${isExpandable && !isExpanded ? 'm-claim--max-h-[180px]' : ''}
      `}
    >
      <div
        ref={textEl}
        className={`
          m-claim--relative
          m-claim--p-1
        `}
      >
        {/* Add fade overlay when content is collapsed */}
        {isExpandable && !isExpanded && (
          <div
            className="m-claim--pointer-events-none m-claim--absolute m-claim--inset-x-0 m-claim--top-0 m-claim--z-40 m-claim--h-[200px]"
            style={{
              background:
                'linear-gradient(to bottom, transparent 25%, hsl(var(--manifold-color-hsl--surface--primary)) 100%)',
            }}
          />
        )}

        {/* Using a crazy class to remove padding from markdown's container */}
        <div className="[&_.rcl--p-4]:m-claim--p-0">
          <MarkdownRenderer markdownText={description} />
        </div>

        {isExpandable && (
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className={StringUtils.classnames(
              'm-claim--absolute',
              isExpanded ? 'm-claim--bottom-0' : 'm-claim--top-[140px]',
              'm-claim--right-2',
              'm-claim--text-left',
              'm-claim--py-2 m-claim--px-4',
              'm-claim--bg-surface-contrast',
              'm-claim--text-secondary hover:m-claim--text-primary',
              'm-claim--bg-surface-secondary',
              'hover:m-claim--bg-surface-accent',
              'm-claim--transition-all m-claim--duration-250',
              'm-claim--uppercase m-claim--text-sm',
              'm-claim--rounded-md',
              'm-claim--outline-none',
              'm-claim--z-40',
            )}
          >
            {isExpanded ? (
              <Minus
                size={16}
                weight="bold"
              />
            ) : (
              <Plus
                size={16}
                weight="bold"
              />
            )}
          </button>
        )}
      </div>
    </div>
  );
}
